import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class Logout {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<void> {
    return this.authenticationRepository.logout()
  }
}
